/**
 * Composant de bouton de catégorie pour l'interface du quiz
 * Affiche les statistiques d'une catégorie (Histoire par défaut)
 */
import "../styles/setting.css";
import "../styles/bouton_act.css";

/**
 * BoutonAct - Composant d'affichage de catégorie de quiz
 * @param {Object} props - Les propriétés du composant
 * @param {string} props.className - Classes CSS additionnelles pour le style
 * @returns {JSX.Element} Carte de catégorie avec statistiques
 */
export const BoutonAct = ({ className, contenu, categorie }) => {
    return (
        <div className={`bouton-act ${className}`} data-category={categorie}>
            <p data-category={categorie}>{contenu}</p>
        </div>
    );
};
